<li *ngIf="!item.url && !item.urlExternal && !item.command && !item.children && !item.link && item.visible && item.filtered"
    class="eui-menu-item eui-menu-item__category"
    [class.eui-menu-item--disabled]="item.disabled"
    [attr.aria-disabled]="item.disabled"
    role="menuitem"
    [euiTooltip]="(hasTooltip || isCollapsed) && !item.expanded ? (item | euiMenuTooltipContent: externalLinkLabel) : null"
    euiTooltipRounded position="after">

    <span class="eui-menu-item__category-icon eui-u-color-{{item?.iconTypeClass}} eui-icon"
        [ngClass]="hasIcon && item.iconClass ? item.iconClass : (isCollapsed ? 'eui-menu-item__category-icon--default' : 'eui-menu-item__category-icon--none')"
        [attr.aria-label]="item.iconLabel">
    </span>

    <span class="eui-menu-item__category-label">
        <span class="eui-menu-item__label">{{item.label}}</span>
    </span>
</li>

<li *ngIf="(item.url || item.urlExternal || item.children || item.command || item.link) && !item.link && item.visible && item.filtered"
    role="menuitem"
    [attr.aria-haspopup]="!!item.children"
    class="eui-menu-item"
    [class.eui-menu-item--expanded]="item.expanded"
    [euiTooltip]="(hasTooltip || isCollapsed) && !item.expanded ? (item | euiMenuTooltipContent: externalLinkLabel) : null"
    euiTooltipRounded position="after">

    <a (click)="onClick($event)"
        [routerLink]="item.url ? item.url : null"
        class="eui-menu-item__link"
        [class.eui-menu-item--disabled]="item.disabled"
        [attr.aria-disabled]="item.disabled"
        [routerLinkActive]="item.url ? 'eui-menu-item__link--active' : ''"
        [class.eui-menu-item__link--active]="item.active">

        <ng-template *ngTemplateOutlet="linkContent" [ngTemplateOutletContext]="{ $implicit: item }"></ng-template>

    </a>

    <ng-template *ngTemplateOutlet="content"></ng-template>
</li>

<li *ngIf="!item.url && !item.urlExternal && !item.command && !item.children && item.link && item.visible && item.filtered"
    role="menuitem"
    [attr.aria-haspopup]="!!item.children"
    class="eui-menu-item"
    [class.eui-menu-item--expanded]="item.expanded"
    [euiTooltip]="(hasTooltip || isCollapsed) && !item.expanded ? (item | euiMenuTooltipContent: externalLinkLabel) : null"
    euiTooltipRounded position="after">

    <a (click)="onClick($event)"
        class="eui-menu-item__link"
        [class.eui-menu-item--disabled]="item.disabled"
        [attr.aria-disabled]="item.disabled"
        [class.eui-menu-item__link--active]="item.active"
        href="javascript:void(0)">

        <ng-template *ngTemplateOutlet="linkContent" [ngTemplateOutletContext]="{ $implicit: item }"></ng-template>

    </a>

    <ng-template *ngTemplateOutlet="content"></ng-template>
</li>


<ng-template #linkContent>
    <span class="eui-menu-item__link-icon eui-u-color-{{item?.iconTypeClass}} eui-icon"
        [ngClass]="hasIcon && item.iconClass ? item.iconClass : (isCollapsed && !item.hasMarker ? 'eui-menu-item__link-icon--default eui-icon-circle' : 'eui-menu-item__link-icon--none')"
        [attr.aria-label]="item.iconLabel">
    </span>

    <span *ngIf="item.hasMarker"
            class="eui-menu-item__link-marker eui-menu-item__link-marker--default eui-icon eui-icon-circle eui-u-color-{{item?.markerTypeClass}}"
            [attr.aria-label]="item.markerTypeClass + ' ' + 'marker'">
    </span>

    <span class="eui-menu-item__link-label"
        [class.eui-menu-item--disabled]="item.disabled"
        [attr.aria-disabled]="item.disabled">
            <span class="eui-menu-item__label">{{item.label}}</span>
            <span *ngIf="item.urlExternal" class="eui-menu-item__label-external eui-icon eui-icon-ecl-external"></span>
    </span>

    <div class="eui-menu-item__link-right-content">
        <eui-chip *ngIf="item.tagLabel" euiSize2XS euiRounded euiOutline styleClass="eui-menu-item__link-tag-label eui-chip--{{item.tagTypeClass}}">
            <span euiLabel>{{item.tagLabel}}</span>
        </eui-chip>

        <button *ngIf="item.children" euiButton euiRounded euiIconButton euiSizeS euiBasicButton euiSecondary
                [euiDisabled]="item.disabled"
                class="eui-menu-item__link-toggle"
                [attr.aria-label]="item.expanded ? expandMenuLabel : collapseMenuLabel"
                (click)="onExpandToggle($event)">
            <span class="eui-icon" [ngClass]="item.expanded ? 'eui-icon-angle-up' : 'eui-icon-angle-down'"></span>
        </button>
    </div>
</ng-template>

<ng-template #content>
    <ng-content></ng-content>
</ng-template>
